// extracted by css-extract-rspack-plugin
export default {"dropdownLoadingContent":"_e17ad473"};